<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/hello' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>统计数据</el-breadcrumb-item>
      <el-breadcrumb-item>游戏统计数据</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:15px;">
      <el-form
        ref="queryForm"
        :model="userSearchData"
        size="small"
        :inline="true"
        label-width="68px"
      >
        <el-form-item label="App类型">
            <el-select placeholder="请选择App类型"  v-model="userSearchData.app_id"
                style="width: 100px">
                <el-option
                  v-for="item in appids"
                  :key="item.app_id"
                  :label="item.name"
                  :value="item.app_id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="专区类型" prop="game_type">
          <el-select
            v-model="userSearchData.game_type"
            clearable
            style="width: 150px">
            <el-option label="不选择" value="0"/>
            <el-option label="红包" value="1"/>
            <el-option label="专区" value="2"/>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏名称">
          <input
            v-model="searchInput"
            placeholder="输入关键字"/>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="searchGameDataInfo()"
            >游戏搜索</el-button>
          <el-select
            placeholder="请选择游戏名称"  v-model="userSearchData.game_id">
            <el-option
              v-for="item in allGameInfos"
              :key="item.id"
              :label="item.game_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据方案">
            <el-select placeholder="请选择数据方案类型"  v-model="userSearchData.group_id">
                <el-option
                  v-for="item in groups"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="时间类型" prop="date_type">
          <el-select
            v-model="userSearchData.date_type"
            clearable
            style="width: 150px"
          >
          <el-option label="不选择" value="-1"/>
            <el-option label="日总计" value="0"/>
            <el-option label="月总计" value="1"/>
            <el-option label="全部总计" value="2"/>
          </el-select>
        </el-form-item>
        <el-form-item label="开始月份" v-if="showMonthRange">
          <el-date-picker
            v-model="userSearchData.create_month_time"
            style="width: 220px"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择开始月份"
          />
        </el-form-item>
        <el-form-item label="结束月份" v-if="showMonthRange">
          <el-date-picker
            v-model="userSearchData.update_month_time"
            style="width: 220px"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择结束月份"
          />
        </el-form-item>
        <el-form-item label="选择日期" v-if="showDateRange">
          <el-date-picker
            v-model="userSearchData.time"
            style="width: 220px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="降序排序" prop="sort_type">
          <el-select
            v-model="userSearchData.sort_type"
            clearable
            style="width: 220px">
            <el-option label="不选择" value="0"/>
            <el-option label="玩家人数" value="1"/>
            <el-option label="男玩家人数" value="2"/>
            <el-option label="女玩家人数" value="3"/>
            <el-option label="充值人数" value="4"/>
            <el-option label="充值" value="5"/>
            <el-option label="总流水" value="6"/>
            <el-option label="发放红包" value="7"/>
            <el-option label="发放购物点" value="8"/>
            <el-option label="公司利润" value="9"/>
            <el-option label="用户Appu" value="10"/>
            <el-option label="游戏付费率" value="11"/>
          </el-select>
        </el-form-item>
        <el-form-item label="过滤休闲" prop="delete_type">
          <el-select
            v-model="userSearchData.delete_type"
            clearable
            style="width: 150px"
          >
          <el-option label="不选择" value="-1"/>
            <el-option label="不过滤" value="0"/>
            <el-option label="过滤" value="1"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="searchDataInfo()"
            >统计搜索</el-button>
          <el-button v-if="showUpdateAD" type="primary" icon="el-icon-search" size="mini" @click="updateAdverPrice()"
            >编辑广告费</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table v-loading="pageloading" border :data="versionListData" stripe style="width: 100%" ref="table">
        <el-table-column
          v-for="column in tableColumns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :width="column.width" 
          :fixed="column.fixed || null"
          >
        </el-table-column>
        <el-table-column prop="address" label="操作" width="160" fixed="right" v-if="isShowUpdatePrice">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="edit(scope.row)"
              >编辑广告费</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100, 200, 300, 500]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
      <!-- 分页功能 -->
    </el-card>
  </div>
</template>

<script>
// import { changeDateFormat } from "@/utils/util";
import { getcurrentTime } from "@/utils/public";
import { isString } from '../../utils/util';
export default {
  data() {
    return {
      searchInput: "",
      showUpdateAD: false,
      isShowUpdatePrice: false,
      pageloading: false,
      editpageloading: false,
      showDateRange: false,
      showMonthRange: false,
      currentPage: 1,
      pageSize: 10,
      total: 0, //请求列表的总条数
      userSearchData: {
        name: "",
        app_id: 0,
        create_month_time: "",
        update_month_time: "",
        time: "",
        type: "",
        date_type: "",
        group_id: 0,
        game_type: "",
        game_id: 0,
        sort_type: 0,
        delete_type: -1
      },
      appids: [
        {
          app_id: "",
          name: "",
        }
      ],
      channelids: [
        {
          channel_id: "",
          channel_name: "",
        }
      ],
      groups: [
        {
          id: "",
          name: "",
        }
      ],
      allGameInfos: [],
      tableData: [],
      columns: [],
      tableColumns: [],
      versionListData: [],
      addVisible: false,
      editVisible: false
    };
  },

  mounted() {
    this.searchAllAppidsData();
    // this.searchChannelIdsData();
    this.searchAllGourpData();
    this.SelectAllGameInfos("");
  },

  watch: {
    'userSearchData.date_type': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.userSearchData.date_type == 0) { //日
          this.showDateRange = true;
          this.showMonthRange = false;
        } else if (this.userSearchData.date_type == 1) { //月
          this.showDateRange = false;
          this.showMonthRange = true;
        } else {
          this.showDateRange = false;
          this.showMonthRange = false;
        }
      }
    } 
  },

  methods: {
    updateIsNull(value) {
       return `${(value * 100.00).toFixed(2)}%`;
    },
    toPercentage(value) {
       return `${(value * 100.00).toFixed(2)}%`;
    },
    changeDateFormat(time, format = 'YYYY-MM-DD hh:mm:ss') {
      if(!time) return '';
      var datetime = new Date(time);
      var o = {
          'Y+': datetime.getFullYear(),
          "M+": datetime.getMonth() + 1,
          "D+": datetime.getDate(),
          "h+": datetime.getHours(),
          "m+": datetime.getMinutes(),
          "s+": datetime.getSeconds(),
          "q+": Math.floor((datetime.getMonth() + 3) / 3),
          "S": datetime.getMilliseconds()
      };
      if (/(Y+)/.test(format)) format = format.replace(RegExp.$1, (datetime.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
              format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
          }
      }
      return format;
    },
    getAppName(item) {
      var string = ``;
      if (item != null && this.appids != null) {
        for(var i=0; i<this.appids.length; i++) {
          var itemObject = this.appids[i];
          if (itemObject.app_id == item) {
            string = itemObject.name;
            break;
          }
        }
      }
      return string;
    },
    async searchGameDataInfo() {
      this.SelectAllGameInfos(this.searchInput);
    },
    async searchAllAppidsData() {
      this.$axios
      .post("/3699BIApi/AppId/SearchAllData", {})
      .then(res => {
        if (res.data.code == 200) {
          var array = res.data.list;
          var resultData = [];
          var fob = new Object();
          fob["app_id"] = "";
          fob["name"] = "不选择";
          resultData.push(fob);
          for(var i = 0; i < array.length; i++) {
            let itemObject = array[i];
            var ob = new Object();
            for(var k in itemObject) {
                ob[k] = itemObject[k];
            }
            resultData.push(ob);
          }
          this.appids = resultData;
        }
      });
    },
    getChannelName(item) {
      var string = ``;
      if (isString(item)) {
        for(var i=0; i<this.channelids.length; i++) {
          var itemObject = this.channelids[i];
          if (itemObject.channel_id == item) {
            string = itemObject.name;
            break;
          }
        }
      }      
      return string;
    },
    async searchChannelIdsData() {
      this.$axios
      .post("/3699BIApi/ChannelId/SearchAllData", {})
      .then(res => {
        if (res.data.code != 200) {
          this.$message.error(`查询失败:${res.data.msg}`);
          return;
        }
        var array = res.data.list;
        var resultData = [];
        var fob = new Object();
        fob["channel_id"] = "";
        fob["name"] = "不选择";
        resultData.push(fob);
        for(var i = 0; i < array.length; i++) {
          let itemObject = array[i];
          var ob = new Object();
          for(var k in itemObject) {
              ob[k] = itemObject[k];
          }
          resultData.push(ob);
        }
        this.channelids = resultData;
      });
    },
    async SelectAllGameInfos(value) {
      var selectName = ""
      if (value != null) {
          const regex = /[\u4e00-\u9fff]/;
          if (regex.test(value)) {
            selectName = value;
          }          
      }
      console.log(`value： ${value} `);
      console.log(`selectName： ${selectName} `);
      //更新游戏列表数据
      this.$axios
      .post("/3699BIApi/DataGameSum/SelectAllGameInfos",{
          name: String(selectName),
          game_type: Number.parseInt(this.userSearchData.game_type)
      })
      .then(res => {
        if (res.data.code == 200) {
          var array = res.data.list;
          var resultData = [];
          var fob = new Object();
          fob["id"] = "";
          fob["game_name"] = "不选择";
          fob["game_all_name"] = "";
          fob["game_manu_id"] = "";
          fob["game_manu_name"] = "";          
          resultData.push(fob);
          for(var i = 0; i < array.length; i++) {
            let itemObject = array[i];
            var ob = new Object();
            for(var k in itemObject) {
                ob[k] = itemObject[k];
            }
            resultData.push(ob);
          }
          this.allGameInfos = resultData;
        }
      });
    },
    async searchAllGourpData() {
      this.$axios
      .post("/3699BIApi/AdminDataSumShowGroupConfig/SearchData",{
          type: Number.parseInt(1),
          currentPage: 1,
          pageSize: 100
      })
      .then(res => {
        if (res.data.code == 200) {
          var array = res.data.list;
          var resultData = [];
          var fob = new Object();
          fob["id"] = "";
          fob["name"] = "不选择";
          resultData.push(fob);
          for(var i = 0; i < array.length; i++) {
            let itemObject = array[i];
            var ob = new Object();
            for(var k in itemObject) {
                ob[k] = itemObject[k];
            }
            resultData.push(ob);
          }
          this.groups = resultData;
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.searchData(this.userSearchData);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.searchData(this.userSearchData);
    },
    async searchData(requestObject) {
      if (Number.parseInt(requestObject.group_id) <= 0) {
        this.$message.error("数据方案不能为空!");
        return;
      }
      this.searchGameData(requestObject);
    },
    searchGameData(requestObject) {
      this.$axios
      .post("/3699BIApi/DataGameSum/SearchData",{
          app_id: Number.parseInt(requestObject.app_id),
          create_time: requestObject.time[0],
          update_time: requestObject.time[1],
          create_month_time: requestObject.create_month_time,
          update_month_time: requestObject.update_month_time,
          type: Number.parseInt(requestObject.date_type),
          game_id: Number.parseInt(requestObject.game_id),
          group_id: Number.parseInt(requestObject.group_id),
          game_type: Number.parseInt(requestObject.game_type),
          sort_type: Number.parseInt(requestObject.sort_type),
          delete_type: Number.parseInt(requestObject.delete_type),
          currentPage: this.currentPage,
          pageSize: this.pageSize
      })
      .then(res => {
          this.pageloading = false;
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.columns = res.data.columns;
          this.tableColumns = res.data.columns;
          this.updateCurrpageData();
      });
    },
    searchDataInfo() {
      this.pageloading = true;
      this.currentPage = 1;
      this.searchData(this.userSearchData);
    },
    updateCurrpageData() {
      var arrays = [];
      var i = 0;
      var endi = this.total - (this.currentPage-1) * this.pageSize;
      if (endi > this.pageSize) {
        endi = this.pageSize;
      }
      console.log(`updateCurrpageData ${endi} 条`);
      for(; i<endi; i++) {
        if (i < this.total) {
          var itemObject = this.tableData[i];
          arrays.push(itemObject);
        }
      }
      
      this.versionListData = arrays.filter(val => {
        return val;
      });
    },
  }
};
</script>

<style lang="sass" scoped></style>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         


// WEBPACK FOOTER //
// src/views/Data/DataGame.vue